import { Typography } from "components/typography";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "hooks/userHooks";

const UneditableNationalIdAndEmail = () => {
  const { t } = useTranslation();
  const { user } = useCurrentUser();

  return (
    <div>
      <div>
        <Typography insensitive variant="body-x-small" color="GRAY_DARK">
          {t("NATIONAL_IDENTITY")}
        </Typography>
        <Typography
          variant="body"
          style={{ marginTop: "10px", marginBottom: "0" }}
        >
          {user?.nationalIdentity}
        </Typography>
      </div>
      <div>
        <Typography insensitive variant="body-x-small" color="GRAY_DARK">
          {t("EMAIL")}
        </Typography>
        <Typography
          variant="body"
          style={{ marginTop: "10px", marginBottom: "0" }}
        >
          {user?.email}
        </Typography>
      </div>
    </div>
  );
};

export default UneditableNationalIdAndEmail;
